import useCallApi from '../../../../utilities/axios'

const useApiPlayground = () => {
    const callApi = useCallApi()
    const handleClickCallPostApi = async () => {
        const { data } = await callApi.axiosPost<any>({
            url: 'https://gdev.geotalent.co.th/VirtualRunAPI/api/lookup/employee',
            params: {
                keyword: '',
                location: '',
            },
        })

        return data
    }

    const handleClickCallGetApi = async () => {
        const { data } = await callApi.axiosGet<any>({
            url: 'https://docker.geotalent.co.th/wfh-api-dev/api/lookup/reason',
        })
        return data
    }

    return {
        onClickCallPostApi: handleClickCallPostApi,
        onClickCallGetApi: handleClickCallGetApi,
    }
}

export default useApiPlayground
